import { Box, Divider, Grid, MenuItem, Tab, Tabs, Typography } from '@mui/material';
import domtoimage from 'dom-to-image';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

/** TRANSLATION */
import { useTranslation } from 'react-i18next';

/** ROUTE */
import { routeName } from 'routes/routes-name';

/** UTILS || SLICE */
import { handleShow, resetModal, showModal } from 'app/slice/modal.slice';
import {
  TreatmentStateInterface,
  TreatmentStateType,
  checkApprovalRight,
  isEditTootChart,
  loadPromotionTreatments,
  setApprovalRight,
  setEditTootChart,
  setEditTootChartType,
  setTreatmentByKey,
  treatment
} from 'app/slice/treatment.slice';
import { selectMe } from 'app/slice/user.slice';
import { checkPackage, getBranch, getClinicInfo } from 'utils/app.utils';


/** API */
import { fileUrl } from 'api/api';
import TreatmentSummaryApi from 'api/dentists/treatment-summary.api';
import TreatmentsAPI from 'api/dentists/treatment.api';
import HomeApi from 'api/home/home.api';
import ClinicApi from 'api/master/clinic.api';

/** CONSTANTS */
import { exportOPD, exportSSO } from 'component/Print/exportPdf';
import { KEY_STORAGE } from 'constants/common';
import { imgs } from 'constants/images';
import { PACKAGE_ADDONS } from 'constants/package';
import { colors } from 'constants/theme';

/** COMPONENT */
/** Treatments */
import SSO from 'component/Treatments/SSO';
import IndexDoctorNote from 'features/treatments/MainMenu/DoctorNote/Index';
import IndexImage from 'features/treatments/MainMenu/Image/Index';
import IndexOPD from 'features/treatments/MainMenu/OPD/Index';
import IndexVitalSign from 'features/treatments/MainMenu/VitalSign/Index';
/** End Treatments */
import Breadcrumb, { BreadcrumbType } from 'component/Breadcrumb/Breadcrumb';
import Loading from 'component/Loading';
import SendExamination from 'component/Register/SendExamination';
import BtnProfile from 'component/Treatments/BtnProfile';
import MedicalCertificate from 'component/Treatments/MedicalCertificate';
import PopupPatientDetail from 'component/Treatments/PopupPatientDetail';
import PopupSelectPrintProduct from 'component/Treatments/PopupSelectPrintProduct';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import PopupPayment from 'features/finance/payment/component/popupPayment/Index';
import FragmentFooter from 'features/treatments/FragmentFooter';
import IndexSummaryTreatment from 'features/treatments/SummaryTreatment/Index';
import { RawAdditionalType, RawDiscountType, renderSumAdditional, renderSumDiscount } from 'features/treatments/SummaryTreatment/SummaryTreatment';
import { DoctorsType, SUB_TABS_NAME, TABS_NAME } from 'features/treatments/treatmentsIndex';

/** ICON */
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/** STYLE */
import { swalCustom, swalWarning } from 'component/Alert/Swal';
import ReferralEaxmination from 'component/Treatments/Referral-examination';
import * as UseStyled from 'features/finance/payment/UseStyle';
import * as TreatmentsUseStyled from 'features/treatments/UseStyle';

import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import ApprovalApi, { ApprovalStatus } from 'api/approval/approval.api';
import PaymentApi from 'api/counter/payment/payment.api';
import TreatmentApi from 'api/dentists/treatment.api';
import MedicalCertificateDrivingLicense from 'component/Treatments/MedicalCertificateDrivingLicense';
import MedicalCertificate_A5 from 'component/Treatments/MedicalCertificate_A5';
import PopTreatmentDocument from 'component/Treatments/PopTreatmentDocument';
import { PopupConfirmClose } from 'component/Treatments/PopupConfirmClose';
import MedicalCertificateFiveDisease from 'component/Treatments/PopupMedicalCertificateFiveDisease';
import PopupOutStandingPayment, { PDFPayloadOutStandingPaymentProps } from 'component/Treatments/PopupOutStandingPayment';
import PopupTreatmentFees from 'component/Treatments/PopupTreatmentFees';
import ReferralDental from 'component/Treatments/Referral-dental';
import PopupTreatmentConsent from 'component/Treatments/popupTreatmentConsent';
import { Config } from 'config';

interface TabPanelProps {
  children?: React.ReactNode
  index: string
  value: string
}

export default function PaymentCreate() {
  const location = useLocation()
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector(selectMe)
  const isEditTootCharts: any = useSelector(isEditTootChart)
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const modal: boolean = useSelector(handleShow)
  const branchIdServicePoint = getBranch()
  const approvalRight = useSelector(checkApprovalRight)

  const branch_ = getClinicInfo()
  const disabledOpenPopupInfo = localStorage.getItem(KEY_STORAGE.TREATMENT_CLOSE_POPUP)

  const [hasChangeTreatmentCost, setHasChangeTreatmentCost] = useState();
  const [hasChangeTreatmentNote, setHasChangeTreatmentNote] = useState();
  const [hasDiagnosis, setHasDiagnosis] = useState();
  const [hasTreatment, setHasTreatment] = useState();
  const [hasTreatmentCourse, setHasTreatmentCourse] = useState();
  const [hasTreatmentPlan, setHasTreatmentPlan] = useState();
  const [hasDoctorNote, setHasDoctorNote] = useState();
  const [hasChangeProductPrice, sethasChangeProductPrice] = useState();
  const [hasChangeProductDiscountAdditional, setHasChangeProductDiscountAdditional] = useState();
  const [hasCreateDoctorNote, setHasCreateDoctorNote] = useState();
  const [hasDeleteDoctorNote, setHasDeleteDoctorNote] = useState();
  const [hasMed, setHasMed] = useState()
  const [hasProduct, setHasProduct] = useState()

  const [checkViewDX, setCheckViewDX] = useState<boolean>(false)

  const [tabs, setTabs] = useState<TABS_NAME[]>([TABS_NAME.OPD, TABS_NAME.DOCTOR_NOTE, TABS_NAME.IMAGE, TABS_NAME.VITAL_SIGN])
  const [subTabs, setSubTabs] = useState<SUB_TABS_NAME[]>([SUB_TABS_NAME.TX, SUB_TABS_NAME.TXP, SUB_TABS_NAME.TXC, SUB_TABS_NAME.MED, SUB_TABS_NAME.PD])
  const footerTabs: string[] = ['TREATMENTS.FOOTER_TAB.SUMMARY_TREATMENT', 'TREATMENTS.FOOTER_TAB.DIAGNOSIS', 'TREATMENTS.FOOTER_TAB.RECOMMEND']
  const [activeTab, setActiveTab] = useState<TABS_NAME>(TABS_NAME.OPD)
  const [activeSubTab, setActiveSubTab] = useState<SUB_TABS_NAME>(SUB_TABS_NAME.TX)
  const [activeFooterTab, setActiveFooterTab] = useState(0)
  const [isShowPopupDetail, setIsShowPopupDetail] = useState<boolean>(false)

  const [servicePointId, setServicePointId] = useState(0)
  const [patientId, setPatientId] = useState(0)
  const [patient, setPatient]: any[] = useState([])
  const [netDiscount, setNetDiscount] = useState<number>(0)
  const [netAdditional, setNetAdditional] = useState<number>(0)
  const [doctors, setDoctors] = useState<DoctorsType[]>([])

  const [sendExam, setSendExam] = useState(false)
  const [patientCase, setPatientCase] = useState([])

  const [sendPayment, setSendPayment] = useState(false)

  const [anchorElTabletTabs, setAnchorElTabletTabs] = useState<null | HTMLElement>(null)
  const openTabletTabs = Boolean(anchorElTabletTabs)
  const [tabletWidth, setTabletWidth] = useState(0)

  const [anchorElMobileTabs, setAnchorElMobileTabs] = useState<null | HTMLElement>(null)
  const openMobileTabs = Boolean(anchorElMobileTabs)
  const [mobileWidth, setMobileWidth] = useState(0)

  const [exportMedicalCertificate, setExportMedicalCertificate] = useState(false)
  const [exportReferralEaxmination, setExportReferralEaxmination] = useState(false)
  const [exportMedicalServices, setSSO] = useState(false)


  const [showPopupSelectStickerProduct, setShowPopupSelectStickerProduct] = useState(false);

  const [loading, setLoading] = useState(false)
  const [confirmClose, setConfirmClose] = useState(false)
  const [save, setSave] = useState(false)

  const [treatmentConsent, setTreatmentConsent] = useState(false);
  const [exportReferralExamination, setExportReferralExamination] = useState(false)
  const [exportReferralReferralDental, setExportReferralDental] = useState(false)
  const [exportMedicalCertificate_A5, setExportMedicalCertificate_A5] = useState(false)
  const [exportMedicalCertificateFiveDisease, setExportMedicalCertificateFiveDisease] = useState(false)
  const [exportMedicalCertificateDrivingLisense, setExportMedicalCertificateDrivingLisense] = useState(false)

  const [popTreatmentDocument, setPopTreatmentDocument] = useState<boolean>(false)
  const [popTreatmetnFees, setPopTreatmentFees] = useState<boolean>(false)

  const breadcrumbs: BreadcrumbType[] = [{ title: 'PAYMENT.BREADCRUMB.MAIN', path: routeName.payment }, { title: 'PAYMENT.BREADCRUMB.PAYMENT_DETAIL' }]

  const [treatmentCurrent, setTreatmentCurrent] = useState<any>([])
  const [rank, setRank] = useState<any>({})
  const [popOutStandingPayment, setPopOutStandingPayment] = useState<boolean>(false)
  const [outStandingPayment, setOutStandingPayment] = useState<boolean>(false)
  const [dataPatientCase, setDataPatientCase] = useState<any>(null)

  const [errorMessage, setErrorMessage] = useState<any>({
    teeth: '',
    note: ''
  })

  const fetchPatientCase = async (patientCaseId: number) => {
    await HomeApi.patientCase(patientCaseId).then((resp) => {
      setDataPatientCase(resp.data)
    })
  }

  const getPatientCase = async (patientId: number) => {
    await TreatmentsAPI.findPatient(patientId).then((resp) => {
      fetchPatientCase(resp?.data?.patientCase?.patientCaseId)
    })
  }
  /** BLOCK PAGE */
  // const { RouterPrompt, setBlockPage } = useBlockPageWarning()

  useEffect(() => {
    setHasChangeTreatmentCost(user?.hasChangeTreatmentCost)
    setHasChangeTreatmentNote(user?.hasChangeTreatmentNote)
    setHasDiagnosis(user?.hasDiagnosis)
    setHasTreatment(user?.hasTreatment)
    setHasTreatmentCourse(user?.hasTreatmentCourse)
    setHasTreatmentPlan(user?.hasTreatmentPlan)
    setHasDoctorNote(user?.hasDoctorNote)
    sethasChangeProductPrice(user?.hasChangePrice)
    setHasChangeProductDiscountAdditional(user?.hasChangeDiscountAdditional)
    setHasCreateDoctorNote(user?.hasCreateDoctorNote)
    setHasDeleteDoctorNote(user?.hasDeleteDoctorNote)
    setHasMed(user?.hasMed)
    setHasProduct(user?.hasProduct)
    setCheckViewDX(user?.hasDiagnosis === 'PERMISS' ? true : false)
  }, [user]);

  useEffect(() => {
    const addonDoctorNote: TABS_NAME[] = checkPackage(PACKAGE_ADDONS.ADDON_DOCTOR_NOTE) ? [TABS_NAME.DOCTOR_NOTE] : []
    setTabs([TABS_NAME.OPD, ...addonDoctorNote, TABS_NAME.IMAGE, TABS_NAME.VITAL_SIGN])
    const subMenus: any = []
    if (hasDiagnosis === 'PERMISS') subMenus.push(SUB_TABS_NAME.DX)
    if (hasTreatment === 'PERMISS') subMenus.push(SUB_TABS_NAME.TX)
    if (hasTreatmentPlan === 'PERMISS' && checkPackage(PACKAGE_ADDONS.ADDON_TREATMENT_PLAN_MANAGE)) subMenus.push(SUB_TABS_NAME.TXP)
    if (hasTreatmentCourse === 'PERMISS' && checkPackage(PACKAGE_ADDONS.ADDON_TREATMENT_COURSE_MANAGE)) subMenus.push(SUB_TABS_NAME.TXC)
    if (checkPackage(PACKAGE_ADDONS.ADDON_PRODUCTS)) {
      if (hasMed === 'PERMISS') subMenus.push(SUB_TABS_NAME.MED)
      if (hasProduct === 'PERMISS') subMenus.push(SUB_TABS_NAME.PD)
      subMenus.push(SUB_TABS_NAME.MAT)
    }
    setSubTabs([...subMenus])
    setActiveSubTab((hasTreatment === 'PERMISS' && SUB_TABS_NAME.TX) || (hasTreatmentPlan === 'PERMISS' && SUB_TABS_NAME.TXP) || (hasTreatmentCourse === 'PERMISS' && SUB_TABS_NAME.TXC) || SUB_TABS_NAME.MED)
  }, [hasTreatment, hasTreatmentPlan, hasTreatmentCourse])

  useEffect(() => {
    if (treatments.summeryTreatments.length > 0) {
      const index = _.findLastIndex(treatments.summeryTreatments, (item: any) => item.teethType)
      if (treatments.summeryTreatments[index]) {
        dispatch(setTreatmentByKey({ key: 'teethType', value: treatments.summeryTreatments[index].teethType }))
      }
    }
  }, [treatments.summeryTreatments]);


  const loadDoctor = async () => {
    const resp = await ClinicApi.findAllDoctors()
    if (resp.status === 200) setDoctors(resp.data)
  }

  const loadPatient = async () => {
    if (patientId) {
      const patientData = await TreatmentsAPI.findPatient(patientId)
      if (patientData.status === 200 && !_.isEmpty(patientData.data)) {
        if (!patientData.data.patientCase?.patientCaseId) return history.push(routeName.payment)
        setPatient(patientData.data)
        // if (patientData.rankId) {
        //   const member = await RegisterApi.findRankById(patientData.rankId)
        //   setRank(member)
        //   console.log(member, 'member');
        // }
        if (user?.position?.positionId === 2 && (disabledOpenPopupInfo && !_.includes(JSON.parse(disabledOpenPopupInfo), Number(patientId))) || !disabledOpenPopupInfo) onViewHistory()
      } else history.push(routeName.payment)
    }
  }

  const onTreatmentClose = () => {
    if (save) {
      handleTreatmentClose()
    } else {
      onConfirmClose()
    }
  }

  const handleTreatmentClose = async (noneGoTo?: boolean) => {
    const patientCaseId = patient.patientCase?.patientCaseId
    if (patientCaseId) {
      await PaymentApi.sendPayment(patientCaseId)
        .then(() => {
          if (!noneGoTo) {
            setTimeout(() => { window.location.href = routeName.payment }, 500)
          }
        })
    }
  }

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(tabs[newValue])
    dispatch(setEditTootChart(null))
    dispatch(setEditTootChartType(''))
  }

  const onCloseMenu = () => {
    setAnchorElMobileTabs(null)
    setAnchorElTabletTabs(null)
  }

  const handleOpenDropDown = () => {
    const dropdownTabletWidth = Array.from(document.getElementsByClassName('btn-dropdown-menu-tablet-tab') as HTMLCollectionOf<HTMLElement>)
    const dropdownMobileWidth = Array.from(document.getElementsByClassName('btn-dropdown-menu-mobile-tab') as HTMLCollectionOf<HTMLElement>)
    setTabletWidth(Number(dropdownTabletWidth[0]?.offsetWidth))
    setMobileWidth(Number(dropdownMobileWidth[0]?.offsetWidth))
  }

  const onViewHistory = () => {
    dispatch(showModal())
    setIsShowPopupDetail(true)
  }

  const onConfirmClose = () => {
    dispatch(showModal())
    setConfirmClose(true)
    // setIsCancel(false)
  }
  const renderImage = (img: any) => {
    if (!_.isEmpty(img) && !_.isEmpty(img.filePath) && !_.isEmpty(img.fileName)) return `${fileUrl}/${img.filePath}/${img.fileName}`
    else return imgs.defaultAvatar
  }

  const onHandleSaveToothChart = async () => {
    const toothChartFile = {
      patientFileId: treatments?.toothChart?.patientFileId || null,
      base64: '',
      fileExtension: 'png'
    }

    let node: any = ''
    if (treatments.teethType === 'ADULT') {
      node = document.getElementById('tooth-chart')
    } else {
      node = document.getElementById('tooth-chart-child')
    }
    if (node) {
      let base64 = await domtoimage.toPng(node)
      if (base64) {
        const re = 'data:image/png;base64,'
        base64 = base64.replace(re, "'")
        toothChartFile.base64 = base64
      }
    }

    return toothChartFile
  }

  const onCancelTreatmentInvoice = async (doctor: number[]) => {
    const resp = await TreatmentsAPI.findInvoiceTreatment(patient.patientCase?.patientCaseId)
    if (resp.status === 200) {
      resp?.data?.forEach((item: any) => {
        const invoiceId = item?.invoice?.patientInvoiceId
        if (invoiceId && doctor.includes(item?.doctorId)) {
          TreatmentsAPI.deleteInvoiceTreatment(invoiceId)
        }
      })
    }
  }

  const handleTreatmentCurrentChange = () => {
    const newDoctor: number[] = []
    const newTreatment = treatments.summeryTreatments.filter((item: any) => !item?.tempOrderProductId)
    for (const index in newTreatment) {
      const dataTreatment = newTreatment[index]
      if (!treatmentCurrent.some((item: any) => JSON.stringify(item) === JSON.stringify(dataTreatment))) {
        newDoctor.push(dataTreatment?.doctorId || 0)
      }
    }
    return newDoctor
  }

  useEffect(() => {
    if (outStandingPayment) {
      onSaveSummary('save')
      setOutStandingPayment(false)
    }
  }, [outStandingPayment])

  useEffect(() => {
    const isReloadApproval = treatments?.summeryTreatments.some((item: any) => item?.isChangeCost === "1")
    const isReloadPromotion = treatments?.summeryTreatments.some((item: any) => item?.isReload)

    // || isReloadPromotion
    if (treatments?.summeryTreatments && (isReloadApproval || isReloadPromotion)) {
      onSaveSummary('save')
    }
  }, [treatments?.summeryTreatments])

  const onCheckErrorSubmit = () => {
    let newError: any = {
      note: '',
      teeth: ''
    }
    treatments.summeryTreatments?.map((item: any, index: number) => {
      if (!item?.note || !item?.teeth) {
        newError = {
          ...newError,
          'teeth': treatments.summeryTreatments.some((item: any) => !item?.teeth) ? t('กรุณาเลือกซี่ฟัน') : '',
          'note': treatments.summeryTreatments.some((item: any) => !item?.note) ? t('กรุณากรอกข้อมูลเพิ่มเติม') : '',
        }
      }
    })
    return newError
  }


  const confirmDentalRiskAssessment = async (callback: () => void) => {
    if (dataPatientCase?.isNhso === '1') {
      const { data } = await TreatmentApi.findDentalRiskAssessments(patient.patientCase?.patientCaseId)
      if (data) return callback()
      return swalCustom(t('แจ้งเตือน'),
        `เพื่อประสิทธิภาพในการรักษา <br/>
        กรุณาทำการประเมินฟันผุก่อนดำเนินการในขั้นตอนถัดไป`, async (res: any) => {
        if (res) callback()
        // else setDisabledButton(false)
      }, 'question',
        {
          confirmButton: { confirmButtonText: t('BUTTON.CONTINUE') },
          cancelButton: { cancelButtonText: t('BUTTON.CANCEL') }
        }
      )
    } else return callback()
  }

  const onSaveSummary = async (type: 'save' | 'sendExam' | 'sendPayment' | 'exportMedicalCertificate' | 'onExportReferralExamination' | 'onExportMedicalServices' | 'selectStickerProduct' | 'exportMedicalCertificateDrivingLisense' | 'exportMedicalCertificateFiveDisease' | 'onExportMedicalCertificate_A5' | 'onExportReferralDental' | 'treatmentDocument' | 'treatmentFees' | 'treatmentConsent' | 'outStandingPayment') => {
    setLoading(true)
    const summeryTreatments: any = []
    const summeryProducts: any = []
    const summeryDiagnosis: any = []
    const summeryRecommends: any = []
    let checkNewTotal = true

    if (branch_?.pdfInvoiceTreatmentCondition !== "0" && (treatments?.summeryTreatments?.length !== treatmentCurrent?.length || JSON.stringify(treatments.summeryTreatments) !== JSON.stringify(treatmentCurrent))) {
      checkNewTotal = false
    }

    if (!checkNewTotal) {
      onCancelTreatmentInvoice(handleTreatmentCurrentChange())
    }
    _.map(treatments.summeryTreatments, (i: any, index: number) => {
      if (i.operativeTypeId || i.operativeTypeNameEn === 'NHSO') {
        summeryTreatments.push({
          tempOrderTreatmentId: i.tempOrderTreatmentId || null,
          teeth: i?.teeth || null,
          teethJson: i?.teethJson || null,
          operativeId: i.operativeId || 0,
          qty: Number(i.qty) || 0,
          price: Number(i.price) || 0,
          doctorId: _.some(doctors, { 'userId': i.doctorId }) ? i.doctorId : 0,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || '',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit,
          dfAmount: i.dfAmount === null && i.cfAmount === null ? null : Number(i.dfAmount),
          dfUnit: i.dfUnit || '',
          dfDiscountAmount: Number(i.dfDiscountAmount) || 0,
          dfDiscountUnit: i.dfDiscountUnit || '',
          dfAmountNet: i?.dfAmountNet || 0,
          cfAmount: i.dfAmount === null && i.cfAmount === null ? null : Number(i.cfAmount),
          cfDiscountAmount: Number(i.cfDiscountAmount) || 0,
          cfDiscountUnit: i.cfDiscountUnit || '',
          cfAmountNet: Number(i.cfAmountNet) || 0,
          dfRemark: i.dfRemark || '',
          clinicFeeId: Number(i.clinicFeeId) || null,
          total: Number(i.total) || 0,
          note: i.note || '',
          noteNextVisit: i.noteNextVisit || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          nextVisit: i.nextVisit || null,
          commission: i.commission || 0,
          refItemId: i?.refItemId || '',
          isChangeCost: i?.isChangeCost || "0",
          bodyData: i?.bodyData || "",
          newBodyData: i?.newBodyData || "",
          requestReason: i?.requestReason || "",
          promotion: i?.promotion?.length ? i?.promotion.map((item: any) => {
            return {
              promotionBranchId: item?.promotionBranchId,
              promotionType: item?.promotionType || item?.type,
              promotionId: item?.promotionId,
              isMain: item?.isMain || '0',
              groupNumber: item?.groupNumber || 0
            }
          }) : [],
          promotionDiscount: i?.promotionDiscount || 0,
          promotionDiscountUnit: i?.promotionDiscountUnit || "BAHT",
          dfPromotionDiscountAmount: i?.dfPromotionDiscountAmount || 0,
          dfPromotionDiscountUnit: i?.dfPromotionDiscountUnit || "BAHT",
          cfPromotionDiscountAmount: i?.cfPromotionDiscountAmount || 0,
          cfPromotionDiscountUnit: i?.cfPromotionDiscountUnit || "BAHT",
          // 
          voucherListId: i?.voucherListId || 0,
          voucherDiscount: i?.voucherDiscount || 0,
          voucherDiscountUnit: i?.voucherDiscountUnit || "BAHT",
          dfVoucherDiscountAmount: i?.dfVoucherDiscountAmount || 0,
          dfVoucherDiscountUnit: i?.dfVoucherDiscountUnit || "BAHT",
          cfVoucherDiscountAmount: i?.cfVoucherDiscountAmount || 0,
          cfVoucherDiscountUnit: i?.cfVoucherDiscountUnit || "BAHT",
          // 
          installment: i?.installment || null,
          operativeCode: i.operativeCode || null
        })
      }

      if (!i.operativeTypeId && i.operativeTypeNameEn !== 'NHSO') {
        summeryProducts.push({
          tempOrderProductId: i.tempOrderProductId || null,
          inventoryId: i.inventoryId,
          itemId: i.itemId,
          itemName: i.itemName,
          group: i.group,
          qty: Number(i.qty),
          price: Number(i.price),
          doctorId: _.some(doctors, { 'userId': i.doctorId }) ? i.doctorId : 0,
          discount: Number(i.discount) || 0,
          discountUnit: i.discountUnit || 'BAHT',
          additional: Number(i.additional) || 0,
          additionalUnit: i.additionalUnit || 'BAHT',
          note: i.note || '',
          refType: i.refType || null,
          refId: i.refId || 0,
          total: Number(i.total) || 0,
          commission: i.commission || 0,
          promotion: i?.promotion?.length ? i?.promotion.map((item: any) => {
            return {
              promotionBranchId: item?.promotionBranchId,
              promotionType: item?.promotionType || item?.type,
              promotionId: item?.promotionId,
              isMain: item?.isMain || '0',
              groupNumber: item?.groupNumber || 0
            }
          }) : [],
          promotionDiscount: i?.promotionDiscount || 0,
          promotionDiscountUnit: i?.promotionDiscountUnit || "BAHT",
          // 
          voucherListId: i?.voucherListId || 0,
          voucherDiscount: i?.voucherDiscount || 0,
          voucherDiscountUnit: i?.voucherDiscountUnit || "BAHT",
        })
      }
    })


    _.map(treatments.patientDiagnosis, (i: any, index: number) => {
      summeryDiagnosis.push({
        patientDiagnosisId: i.patientDiagnosisId || null,
        diagnosisId: Number(i.diagnosisId) || 0,
        doctorId: _.some(doctors, { 'userId': Number(i.doctorId) }) ? Number(i.doctorId) : 0,
        note: i.note || '',
        teeth: i?.teeth || null,
        teethJson: i?.teethJson || null,
        teethType: i?.teethType || treatments?.teethType || 'ADULT',
        refItemId: JSON.stringify(i?.refItemId || '[]') || '[]'
      })
    })

    _.map(treatments.patientRecommends, (i: any, index: number) => {
      summeryRecommends.push({
        patientRecommendId: i.patientRecommendId || null,
        recommendId: i.recommendId,
        refItemId: JSON.stringify(i?.refItemId || '[]') || '[]'
      })
    })

    const dataOutStandingPayment: PDFPayloadOutStandingPaymentProps = { ...treatments?.outStandingPayment }

    const summary: TreatmentStateType = {
      importantSymptomsDoctor: patient.importantSymptomsDoctor || '',
      teethType: treatments?.teethType || 'ADULT',
      toothChart: await onHandleSaveToothChart(),
      servicePointId: servicePointId,
      summeryTreatments: summeryTreatments,
      summeryProducts: summeryProducts,
      patientDiagnosis: summeryDiagnosis,
      patientRecommends: summeryRecommends,
      status: "PAYMENT",
      ...dataOutStandingPayment
    }

    if (_.some(summary.summeryTreatments, { 'qty': 0 }) || _.some(summary.summeryProducts, { 'qty': 0 })) {
      setLoading(false)
      return notiError(t(`TREATMENT_SUMMARY.MESSAGE.${_.some(summary.summeryTreatments, { 'qty': 0 }) ? 'NO_OPERATIVE_QTY' : 'NO_PRODUCT_QTY'}`), '', null, null, 'register-page')
    }

    if (_.some(summary.summeryTreatments, { 'doctorId': 0 })) {
      setLoading(false)
      return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_TREATMENT'), '', null, null, 'register-page')
    }
    if (Config.IS_TDH === '1' || Config.IS_DIO === '1') {
      if (_.some(summary.summeryProducts, { group: 'MEDICINE', 'doctorId': 0 })) {
        setLoading(false)
        return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_MEDICINE'), '', null, null, 'register-page')
      }

      if (_.some(summary.summeryProducts, { group: 'PRODUCT', 'doctorId': 0 })) {
        setLoading(false)
        return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_PRODUCT'), '', null, null, 'register-page')
      }

      if (_.some(summary.summeryProducts, { group: 'MATERIAL', 'doctorId': 0 })) {
        setLoading(false)
        return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_PRODUCT'), '', null, null, 'register-page')
      }
    }

    if (_.some(summary.patientDiagnosis, { 'doctorId': 0 })) {
      setLoading(false)
      return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_DIAGNOSIS'), '', null, null, 'register-page')
    }

    if (dataPatientCase?.isNhso === '1') {
      if (summary.patientDiagnosis?.length === 0) {
        setLoading(false)
        return notiError(t('กรุณาเลือก รายการคำวินิจฉัย'))
      }

      const newError = onCheckErrorSubmit()
      if (Object?.values(newError).some(value => value !== "")) {
        setErrorMessage(newError)
        setLoading(false)
        return
      }
    }

    try {
      await TreatmentSummaryApi.treatmentSummaryStore(patient.patientCase?.patientCaseId, summary).then(async (resp) => {
        if (resp.status === 201) {
          // setBlockPage(false)
          const respFindSummary = await TreatmentSummaryApi.findTreatmentSummary(patient.patientCase?.patientCaseId)
          if (respFindSummary.status === 200) {
            const checkDoctor: any = _.filter(respFindSummary.data.summeryTreatments, (treatmentFindSummary: any, index: number) => {
              return !treatmentFindSummary.doctorId
            })

            if (checkDoctor.length) return swalWarning('TREATMENT_SUMMARY.MESSAGE.PLS_SELECT_DOCTOR')
            setTreatmentCurrent([...respFindSummary.data.summeryTreatments, ...respFindSummary.data.summeryProducts])
            dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...respFindSummary.data.summeryTreatments, ...respFindSummary.data.summeryProducts] }))
            dispatch(loadPromotionTreatments(patientId, [...respFindSummary.data.summeryTreatments, ...respFindSummary.data.summeryProducts]))

            const newPatientDiagnosis: any = []
            if (!_.isEmpty(respFindSummary.data.patientDiagnosis)) {
              _.map(respFindSummary.data.patientDiagnosis, (prod, index) => {
                newPatientDiagnosis.push({ ...prod, refItemId: JSON.parse(prod.refItemId || []) })
              })
            }
            dispatch(setTreatmentByKey({ key: 'patientDiagnosis', value: [...newPatientDiagnosis] }))
            const newPatientRecommends: any = []
            if (!_.isEmpty(respFindSummary.data.patientRecommends)) {
              _.map(respFindSummary.data.patientRecommends, (prod, index) => {
                newPatientRecommends.push({ ...prod, refItemId: JSON.parse(prod.refItemId || []) })
              })
            }
            dispatch(setTreatmentByKey({ key: 'patientRecommends', value: [...newPatientRecommends] }))
          }

          if (type === 'save') return notiSuccess(t('TREATMENT_SUMMARY.MESSAGE.SUCCESS.SAVE'), '', null, null, 'register-page')
          if (type === 'sendExam') return
          if (type === 'sendPayment') return onCheckOpenPopPayment(() => {
            const newTotal = [...respFindSummary.data.summeryTreatments, ...respFindSummary.data.summeryProducts].reduce((accumulator: any, item: any) => {
              return accumulator + ((item?.total || 0));
            }, 0)
            if (respFindSummary?.data?.overdueTotal && respFindSummary?.data?.overdueTotal > newTotal) {
              swalCustom(
                t('MODAL_OUTSTANDINGPAYMENT.MESSAGE.ERROR_PAYMENT'),
                t('MODAL_OUTSTANDINGPAYMENT.MESSAGE.ERROR_PAYMENT_SUB'),
                () => onOutStandingPayment(),
                'warning',
                { cancelButton: { showCancelButton: false }, showCloseButton: false }
              )
            } else {
              setSendPayment(true)
            }
          })
          if (type === 'exportMedicalCertificate') return
          if (type === 'onExportMedicalServices') return setSSO(true)
          if (type === 'onExportMedicalCertificate_A5') return setExportMedicalCertificate_A5(true)
          if (type === 'onExportReferralExamination') return setExportReferralEaxmination(true)
          if (type === 'onExportReferralDental') return setExportReferralDental(true)
          if (type === 'selectStickerProduct') return onOpenSelectStickerProduct()
          if (type === 'exportMedicalCertificateFiveDisease') return onExportMedicalCertificateFiveDisease()
          if (type === 'exportMedicalCertificateDrivingLisense') return onExportMedicalCertificateDrivingLisense()
          if (type === 'treatmentDocument') return onPopTreatmentDocument()
          if (type === 'treatmentFees') return onCheckOpenPopPayment(() => onPopTreatmentFees())
          if (type === 'treatmentConsent') return onCheckOpenPopPayment(() => onTreatmentConsent())
          if (type === 'outStandingPayment') return onCheckOpenPopPayment(() => onOutStandingPayment())
        } else {
          return notiError(resp.response.data.message, '', null, null, 'register-page')
        }
      }).catch((e) => {
        const message = e?.response?.data?.message
        if (message === 'TREATMENT_NOT_FOUND' || message === 'PRODUCT_NOT_FOUND') {
          return swalWarning(`รายการ ${e?.response?.data?.name} นั้นถูกลบไปแล้ว กรุณาลบรายการออก`)
        }
        if (message === 'PRODUCT_NOT_ENOUGH' || message === 'MEDICINE_NOT_ENOUGH') {
          notiError(`${t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_PRODUCT_COUNT')} ${e?.response?.data?.name || ''} ${t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_PRODUCT_COUNT_NOT')}`)
        }
        if (message === 'WRONG_STATUS_VISIT') {
          return swalWarning(t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_PATIENT'), t('TREATMENT_SUMMARY.MESSAGE.ERROR.ERROR_VISIT_SUCCESS'), () => { window.location.href = routeName.payment })
        }
      }).finally(() => setLoading(false))

    } catch (error: any) {
      if (error?.response?.data?.message === 'PRODUCT_NOT_ENOUGH' || error?.response?.data?.message === 'MEDICINE_NOT_ENOUGH') {
        notiError(t(`จำนวนสินค้า ${error?.response?.data?.name || ''}  ไม่เพียงพอ`))
      }

    }
  }

  const handleErrorApprovalPending = () => {
    swalCustom(
      t('APPROVELLIST.FILTER.PENDING'),
      `<div >${t('APPROVELLIST.MESSAGE.SAVE_APPROVAL_TITLE')} ${t('APPROVELLIST.MESSAGE.SAVE_APPROVAL_SUB')}</div>`,
      () => console.log(),
      'warning',
      {
        cancelButton: { cancelButtonText: t('BUTTON.ENTER') },
        confirmButton: { showConfirmButton: false },
        showCloseButton: false,
      }
    )
  }

  const onCheckOpenPopPayment = (func: () => void) => {
    if (treatments.summeryTreatments?.some((item: any) => item?.approvalItems?.status === ApprovalStatus.PENDING) && approvalRight?.hasChangeCost) {
      return handleErrorApprovalPending()
    } else {
      return func()
    }
  }

  const onSendExam = async () => {
    await confirmDentalRiskAssessment(async () => {

      await onSaveSummary('sendExam')
      const resp = await HomeApi.patientCase(patient.patientCase?.patientCaseId)
      if (resp.status === 200 && !_.isEmpty(resp.data)) {
        setPatientCase(resp.data)
        setSendExam(true)
      } else setPatientCase([])

    })

  }

  const onOpenSelectStickerProduct = () => {
    setShowPopupSelectStickerProduct(true)
    dispatch(showModal())
  }

  const onPayment = async () => {
    await confirmDentalRiskAssessment(async () => {
      if (!treatments.summeryTreatments.length) return swalWarning(t('TREATMENT_SUMMARY.MESSAGE.PLS_SELECT_TREATMENT'), '', null)
      await onSaveSummary('sendPayment')
    })
  }

  const onExportMedicalCertificate = async () => {
    await onSaveSummary('exportMedicalCertificate')
    const resp = await HomeApi.patientCase(patient.patientCase?.patientCaseId)
    if (resp.status === 200 && !_.isEmpty(resp.data)) {
      setPatientCase(resp.data)
      setExportMedicalCertificate(true)
      dispatch(showModal())
    } else setPatientCase([])
  }

  const onExportMedicalCertificateFiveDisease = () => {
    HomeApi.patientCase(patient.patientCase?.patientCaseId)
      .then(({ data }) => {
        setPatientCase(data)
        setExportMedicalCertificateFiveDisease(true)
        dispatch(showModal())
      })
      .catch((e) => { return })
  }

  const onExportMedicalCertificateDrivingLisense = () => {
    HomeApi.patientCase(patient.patientCase?.patientCaseId)
      .then(({ data }) => {
        setPatientCase(data)
        setExportMedicalCertificateDrivingLisense(true)
        dispatch(showModal())
      })
      .catch((e) => { return })
  }


  const onExportMedicalServices = async () => {
    await onSaveSummary('onExportMedicalServices')
    const resp = await HomeApi.patientCase(patient.patientCase?.patientCaseId)
    if (resp.status === 200 && !_.isEmpty(resp.data)) {
      setPatientCase(resp.data)
      dispatch(showModal())
    } else setPatientCase([])
  }

  const onExportReferralExamination = async () => {
    await onSaveSummary('onExportReferralExamination')
    const resp = await HomeApi.patientCase(patient.patientCase?.patientCaseId)
    if (resp.status === 200 && !_.isEmpty(resp.data)) {
      setPatientCase(resp.data)
      dispatch(showModal())
    } else setPatientCase([])
  }

  const onExportMedicalCertificate_A5 = async () => {
    await onSaveSummary('onExportMedicalCertificate_A5')
    const resp = await HomeApi.patientCase(patient.patientCase?.patientCaseId)
    if (resp.status === 200 && !_.isEmpty(resp.data)) {
      setPatientCase(resp.data)
      dispatch(showModal())
    } else setPatientCase([])
  }

  const onExportReferralDental = async () => {
    await onSaveSummary('onExportReferralDental')
    const resp = await HomeApi.patientCase(patient.patientCase?.patientCaseId)
    if (resp.status === 200 && !_.isEmpty(resp.data)) {
      setPatientCase(resp.data)
      dispatch(showModal())
    } else setPatientCase([])
  }

  const onTreatmentConsent = () => {
    dispatch(showModal())
    return setTreatmentConsent(true)
  }

  const onPopTreatmentFees = () => {
    dispatch(showModal())
    return setPopTreatmentFees(true)
  }

  const onPopTreatmentDocument = () => {
    dispatch(showModal())
    return setPopTreatmentDocument(true)
  }

  const onOutStandingPayment = () => {
    dispatch(showModal())
    return setPopOutStandingPayment(true)
  }

  useEffect(() => {
    const patientState: any = location.state
    if (!_.isEmpty(patientState) && patientState.patientId && patientState.servicePointId) {
      setPatientId(patientState.patientId)
      setServicePointId(patientState.servicePointId)
      getPatientCase(patientState.patientId)
    }
    else history.push(routeName.payment)
  }, [])

  useEffect(() => {
    if (!_.isEmpty(user) && patientId) loadPatient()
  }, [patientId, user])

  useEffect(() => {
    if (activeSubTab !== 'TX') {
      dispatch(setEditTootChart(null))
      dispatch(setEditTootChartType(''))
    }
  }, [activeTab, activeSubTab, activeFooterTab])

  useEffect(() => {
    if (isEditTootCharts !== null && !modal) {
      setActiveTab(tabs[0])
      setActiveSubTab(SUB_TABS_NAME.TX)
    }
  }, [isEditTootCharts])

  useEffect(() => {
    const rawDiscount: number[] = []
    const rawAdditional: number[] = []
    _.map(treatments.summeryTreatments, (i: any, index: number) => {
      let newData = i
      if (i?.approvalItems?.status === ApprovalStatus.PENDING) {
        newData = JSON.parse(i?.approvalItems?.body)
      }
      const additional: RawAdditionalType = {
        price: newData.price,
        qty: newData.qty,
        additional: Number(newData.additional || 0),
        additionalUnit: newData.additionalUnit,
      }
      const discount: RawDiscountType = {
        price: newData.price,
        qty: newData.qty,
        discount: Number(newData.discount || 0),
        discountUnit: i.discountUnit,
        dfUnit: newData.dfUnit || 0,
        dfAmount: Number(newData.dfAmount || 0),
        dfDiscountAmount: Number(newData.dfDiscountAmount || 0),
        dfDiscountUnit: newData.dfDiscountUnit || 0,
        cfAmount: Number(newData.cfAmount) || 0,
        cfDiscountAmount: Number(newData.cfDiscountAmount || 0),
        cfDiscountUnit: newData.cfDiscountUnit,
        additionalNet: renderSumAdditional(additional),
        doctorFeeAmount: newData.doctorFeeAmount || 0,
        clinicFeeAmount: newData.clinicFeeAmount || 0,
        additional: Number(newData.additional || 0),
        additionalUnit: newData.additionalUnit,
      }
      rawDiscount.push(renderSumDiscount(discount))
      rawAdditional.push(renderSumAdditional(additional))
    })
    setNetDiscount(_.sum(rawDiscount))
    setNetAdditional(_.sum(rawAdditional))
  }, [treatments.summeryTreatments])

  const loadCheckApprovePermiss = async () => {
    await ApprovalApi.checkApprovePermiss().then(({ data }) => {
      if (data) {
        dispatch(setApprovalRight(data))
      }
    })
  }

  useEffect(() => {
    loadDoctor()
    loadCheckApprovePermiss()
    // setBlockPage(true)
  }, [])

  useEffect(() => {
    if (!modal) {
      setExportMedicalCertificate(false)
      setIsShowPopupDetail(false)
      setShowPopupSelectStickerProduct(false)
      setConfirmClose(false)
      setPopTreatmentDocument(false)
      dispatch(resetModal())
    }
  }, [modal]);

  const exportOpd = async (valuePatientId: number) => {
    setLoading(true)
    exportOPD(valuePatientId).catch((e) => { setLoading(false) }).finally(() => { setLoading(false) })
  }

  const handlePatientCode = () => {
    if (branch_?.patientCodeQueue === '1') {
      return patient.cnNumber ?? ''
    }
    if (branch_?.patientCodeQueue === '0') {
      return patient.branchCnNumber ?? ''
    }

    if (branch_?.patientCodeQueue === '2') {
      return patient.snCode ?? ''
    }
  }



  return (
    <Box className="px-3 pt-3 pb-4">
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <Box sx={{ paddingBottom: '56px' }}>
        <Grid container spacing={2}>
          <Grid item className="w-100">
            <TreatmentsUseStyled.CardProfile className="d-flex px-3" onClick={onViewHistory}>
              <BtnProfile profile={renderImage(patient.profile)} branchCnNumber={handlePatientCode()} firstName={patient.firstname} lastName={patient.lastname} rankId={patient.rankId} lastVisit={patient.updatedAt} />
            </TreatmentsUseStyled.CardProfile>
          </Grid>

          {dataPatientCase?.isNhso === '1' &&
            <Grid item xs={12}>
              <Box display="flex" flexDirection="row" alignItems="center" color="#B00020" fontSize="12px" fontWeight={400} gap="4px" paddingBottom="24px" paddingTop="12px">
                <ErrorOutlinedIcon sx={{ fontSize: 13 }} />
                <Typography>การเปิด visit โดยใช้สิทธิสปสช.จะสามารถเลือกรายการตามที่สปสช.กำหนดให้เท่านั้น</Typography>
              </Box>
            </Grid>
          }
          <Grid item className="w-100">
            <UseStyled.CustomTabs>
              <Tabs value={activeTab} onChange={handleChangeTab} aria-label="payment tab" className="d-none d-md-block">
                {_.map(tabs, (title: string, index: number) => {
                  return (
                    (index === 0 && (
                      <>
                        <UseStyled.CustomButton
                          key={`tabChild-${index}`}
                          aria-haspopup="true"
                          aria-expanded={openTabletTabs ? 'true' : undefined}
                          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                            handleChangeTab(event, 0)
                            setAnchorElTabletTabs(event.currentTarget)
                            handleOpenDropDown()
                          }}
                          className={`btn-tab btn-dropdown-menu-tablet-tab ${activeTab === TABS_NAME.OPD ? 'Mui-selected' : ''}`}
                          disableRipple
                          {...a11yProps(index)}
                        >
                          <span>{t(title)}</span>
                          <span className={'d-xl-none pl-1'}>({activeSubTab})</span>
                          <FontAwesomeIcon icon={faCaretDown} className={'icon-selector d-xl-none'} />
                        </UseStyled.CustomButton>
                        <UseStyled.MenuBtnMore
                          id="basic-menu-more"
                          anchorEl={anchorElTabletTabs}
                          open={openTabletTabs}
                          onClose={onCloseMenu}
                          onClick={onCloseMenu}
                          className="d-xl-none"
                          sx={{
                            '.MuiMenu-list': {
                              width: tabletWidth,
                              maxHeight: '270px'
                            }
                          }}
                        >
                          {_.map(subTabs, (subTab: SUB_TABS_NAME, indexSubTab: number) => {
                            return (
                              <MenuItem
                                key={indexSubTab}
                                className={'d-block text-ellipsis'}
                                onClick={() => {
                                  setActiveTab(tabs[0])
                                  setActiveSubTab(subTab)
                                  if (indexSubTab === 0) setActiveFooterTab(1)
                                  else setActiveFooterTab(0)
                                }}
                              >
                                {subTab}
                              </MenuItem>
                            )
                          })}
                        </UseStyled.MenuBtnMore>
                      </>
                    )) || <Tab key={`tab-${index}`} label={t(title)} {...a11yProps(index)} className={`btn-tab ${activeTab === title ? 'Mui-selected' : ''}`} disableRipple />
                  )
                })}
              </Tabs>
            </UseStyled.CustomTabs>
            <UseStyled.CustomTabs className="d-md-none">
              <UseStyled.CustomButton
                id="mobile-tabs"
                aria-controls={openMobileTabs ? 'basic-menu-more' : undefined}
                aria-haspopup="true"
                aria-expanded={openMobileTabs ? 'true' : undefined}
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  setAnchorElMobileTabs(event.currentTarget)
                  handleOpenDropDown()
                }}
                className={'btn-tab btn-dropdown-menu-mobile-tab'}
                disableRipple
              >
                {activeTab === TABS_NAME.OPD ? `OPD (${activeSubTab})` : t(activeTab)}
                <FontAwesomeIcon icon={faCaretDown} className={'icon-selector'} />
              </UseStyled.CustomButton>

              <UseStyled.MenuBtnMore
                id="basic-menu-more"
                anchorEl={anchorElMobileTabs}
                open={openMobileTabs}
                onClose={onCloseMenu}
                onClick={onCloseMenu}
                className="d-xl-none"
                sx={{
                  '.MuiMenu-list': {
                    width: mobileWidth,
                    maxHeight: '270px'
                  }
                }}
              >
                <Typography className="pb-1 px-3" sx={{ fontWeight: 600 }}>
                  {t(tabs[0])}
                </Typography>
                {_.map(subTabs, (subTab: SUB_TABS_NAME, indexSubTab: number) => {
                  return (
                    <MenuItem
                      key={indexSubTab}
                      className={'d-block text-ellipsis'}
                      onClick={() => {
                        setActiveTab(tabs[0])
                        setActiveSubTab(subTab)
                        if (indexSubTab === 0) setActiveFooterTab(1)
                        else setActiveFooterTab(0)
                      }}
                    >
                      {subTab}
                    </MenuItem>
                  )
                })}
                <Divider className="mx-0" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                {_.map(tabs, (title: string, indexTitle: number) => {
                  if (indexTitle > 0)
                    return (
                      <MenuItem key={indexTitle} className={'d-block text-ellipsis'} onClick={() => setActiveTab(tabs[indexTitle])}>
                        {t(title)}
                      </MenuItem>
                    )
                })}
              </UseStyled.MenuBtnMore>
            </UseStyled.CustomTabs>
          </Grid>
          <Grid item className={`w-100 ${activeTab === TABS_NAME.OPD ? 'mt-md-3' : 'mt-3'}`}>
            <TabPanel value={activeTab} index={TABS_NAME.OPD}>
              <IndexOPD
                type='Payment'
                userId={user.userId}
                patient={patient}
                tabs={subTabs}
                activeTab={activeSubTab}
                setActiveTab={(tab: SUB_TABS_NAME) => setActiveSubTab(tab)}
                setFooterActiveTab={(tab: number) => setActiveFooterTab(tab)}
                hasChangeProductPrice={hasChangeProductPrice || 'PERMISS'}
                hasChangeProductDiscountAdditional={hasChangeProductDiscountAdditional || 'PERMISS'}
                hasCreateTreatment={user.hasCreateTreatment || 'PERMISS'}
                hasCreateTreatmentPlan={user.hasCreateTreatmentPlan || 'PERMISS'}
                hasCreateTreatmentCourse={user.hasCreateTreatmentCourse || 'PERMISS'}
                hasDeleteTreatment={user.hasDeleteTreatment || 'PERMISS'}
                hasDeleteTreatmentPlan={user.hasDeleteTreatmentPlan || 'PERMISS'}
                hasDeleteTreatmentCourse={user.hasDeleteTreatmentCourse || 'PERMISS'}
                medShowType={branch_?.medShowType}
                pdShowType={branch_?.pdShowType}
                dataPatientCase={dataPatientCase}
              />

            </TabPanel>
            <TabPanel value={activeTab} index={TABS_NAME.DOCTOR_NOTE}>
              <IndexDoctorNote userId={user.userId} patient={patient} hasDoctorNote={hasDoctorNote || 'PERMISS'} hasCreateDoctorNote={hasCreateDoctorNote || 'PERMISS'} hasDeleteDoctorNote={hasDeleteDoctorNote || 'PERMISS'} />
            </TabPanel>
            <TabPanel value={activeTab} index={TABS_NAME.IMAGE}>
              <IndexImage patient={patient} />
            </TabPanel>
            <TabPanel value={activeTab} index={TABS_NAME.VITAL_SIGN}>
              <IndexVitalSign patient={patient} loadPatient={(val: any) => setPatientId(val)} />
            </TabPanel>
          </Grid>
        </Grid>

        <PopupPatientDetail
          type='payment'
          profile={renderImage(patient.profile)}
          patient={patient}
          showPopup={isShowPopupDetail}
          onClose={() => setIsShowPopupDetail(false)}
          reRenderPatient={() => loadPatient()}
        />
        {activeTab !== TABS_NAME.VITAL_SIGN && (
          <Box className="w-100">
            <IndexSummaryTreatment
              onSave={onSaveSummary}
              userId={user.userId}
              type='Payment'
              tabs={footerTabs}
              activeTab={activeFooterTab}
              setActiveTab={(tab: number) => {
                setActiveFooterTab(tab)
                dispatch(setEditTootChart(null));
                dispatch(setEditTootChartType(''));
                if (tab === 0) setActiveSubTab(SUB_TABS_NAME.TX);
                else if (tab === 1 && checkViewDX) setActiveSubTab(SUB_TABS_NAME.DX);
              }}
              patientCaseId={patient.patientCase?.patientCaseId}
              patientId={patient.patientId}
              patientName={`${patient.firstname} ${patient.lastname}`}
              patientPhone={patient.phone}
              doctors={doctors}
              hasTreatment={hasTreatment || "PERMISS"}
              hasChangeTreatmentCost={hasChangeTreatmentCost || "PERMISS"}
              hasChangeTreatmentNote={hasChangeTreatmentNote || "PERMISS"}
              hasDiagnosis={hasDiagnosis || "PERMISS"}
              hasChangeProductPrice={hasChangeProductPrice || "PERMISS"}
              hasChangeProductDiscountAdditional={hasChangeProductDiscountAdditional || "PERMISS"} hasDeleteTreatment={user?.hasDeleteTreatment || 'PERMISS'}
              handleTreatmentCurrent={setTreatmentCurrent}
              errorMessage={errorMessage}
              isNhso={dataPatientCase?.isNhso === '1'}
            />
          </Box>
        )}
        {activeTab !== TABS_NAME.VITAL_SIGN && (
          <FragmentFooter
            type='Payment'
            onSave={() => onSaveSummary('save').then(() => setSave(true))}
            onSendExam={onSendExam}
            onPayment={() => onPayment()}
            tabActive={activeSubTab}
            netTotal={_.sumBy(treatments.summeryTreatments.map((item: any) => {
              let total = item?.installment ? _.find(item?.installment?.installmentList, (item) => item.status === 'PENDING')?.price : item.total
              if (item?.approvalItems?.status === ApprovalStatus.PENDING) {
                const newData = JSON.parse(item?.approvalItems?.body)
                total = newData?.total
              }
              return { ...item, total }
            }), 'total')}
            netDiscount={netDiscount}
            netAdditional={netAdditional}
            onExportMedicalCertificate={() => onExportMedicalCertificate()}
            onExportMedicalCertificateFiveDisease={() => onSaveSummary('exportMedicalCertificateFiveDisease')}
            onExportMedicalCertificateDrivingLisense={() => onSaveSummary('exportMedicalCertificateDrivingLisense')}
            onExportMedicalCertificate_A5={onExportMedicalCertificate_A5}
            onExportMedicalServices={onExportMedicalServices}
            onExportReferralExamination={onExportReferralExamination}
            onExportReferralDental={onExportReferralDental}
            onTreatmentDocument={() => onSaveSummary('treatmentDocument')}
            onTreatmentConsent={() => onSaveSummary('treatmentConsent')}
            onTreatmentFees={() => onSaveSummary('treatmentFees')}
            onExportSSO={exportSSO}
            onTreatmentClose={() => onTreatmentClose()}
            onExportOPD={() => exportOpd(patient.patientId)}
            patientName={`${patient.firstname} ${patient.lastname}`}
            showButtonPrintMedicineSticker={_.some(treatments.summeryTreatments, { group: 'MEDICINE' })}
            patientCaseId={patient?.patientCase?.patientCaseId}
            onPopupSelectProduct={() => onSaveSummary('selectStickerProduct')}
            onOutStandingPayment={() => onSaveSummary('outStandingPayment')}
          />
        )}
        {sendExam && <SendExamination isShow={sendExam} setIsShow={(show: boolean) => setSendExam(show)} patient={patientCase} type={'payment'} />}
        {sendPayment && (
          <PopupPayment
            type='PAYMENT'
            isShow={sendPayment}
            setIsShow={(show: boolean) => setSendPayment(show)}
            patient={patient}
            onSuccess={() => {
              setSendPayment(false)
              const val = disabledOpenPopupInfo ? JSON.parse(disabledOpenPopupInfo) : []
              const newValueClosePopup = _.filter(val, (v) => Number(v) !== Number(patientId))
              localStorage.setItem(KEY_STORAGE.TREATMENT_CLOSE_POPUP, JSON.stringify(newValueClosePopup))
            }}
            dataPatientCase={dataPatientCase}
          />
        )}
      </Box>

      {exportMedicalCertificate && (
        <MedicalCertificate
          isShow={exportMedicalCertificate}
          setIsShow={(show: boolean) => setExportMedicalCertificate(show)}
          patientId={patient.patientId}
          patientCaseId={patient.patientCase.patientCaseId}
          createdAt={patient.createdAt}
          type={'treatment'}
        />
      )}

      {exportMedicalCertificateFiveDisease && (
        <MedicalCertificateFiveDisease
          isShow={exportMedicalCertificateFiveDisease}
          setIsShow={(show: boolean) => setExportMedicalCertificateFiveDisease(show)}
          patientId={patient.patientId}
          branchId={branchIdServicePoint}
          patient={patient}
          type={'treatment'}
          user={user}
          treatments={treatments}
        />
      )}
      {exportMedicalCertificateDrivingLisense && (
        <MedicalCertificateDrivingLicense
          isShow={exportMedicalCertificateDrivingLisense}
          setIsShow={(show: boolean) => setExportMedicalCertificateDrivingLisense(show)}
          patientId={patient.patientId}
          branchId={branchIdServicePoint}
          patient={patient}
          type={'treatment'}
          user={user}
          treatments={treatments}
        />
      )}

      {exportMedicalServices && (
        <SSO
          isShow={exportMedicalServices}
          setIsShow={(show: boolean) => setSSO(show)}
          patientId={patient.patientId}
          branchId={branchIdServicePoint}
          patient={patient}
          type={'treatment'}
          user={user}
          treatments={treatments}
        />
      )}

      {exportMedicalCertificate_A5 && (
        <MedicalCertificate_A5 isShow={exportMedicalCertificate_A5}
          setIsShow={(show: boolean) => setExportMedicalCertificate_A5(show)}
          patientId={patient.patientId}
          branchId={branchIdServicePoint}
          patient={patient} />
      )}

      {exportReferralEaxmination && (
        <ReferralEaxmination
          isShow={exportReferralEaxmination}
          setIsShow={(show: boolean) => setExportReferralEaxmination(show)}
          patientId={patient.patientId}
          branchId={branchIdServicePoint}
          patient={patient}
        />
      )}

      {
        exportReferralReferralDental && (
          <ReferralDental
            isShow={exportReferralReferralDental}
            setIsShow={(show: boolean) => setExportReferralDental(show)}
            patientId={patient.patientId}
            branchId={branchIdServicePoint}
          />
        )
      }

      {
        treatmentConsent && (
          <PopupTreatmentConsent
            type='treatment'
            patientCaseId={patient?.patientCase?.patientCaseId}
            servicePointId={servicePointId}
            setIsShow={(show: boolean) => setTreatmentConsent(show)}
          />
        )
      }

      {
        showPopupSelectStickerProduct && (
          <PopupSelectPrintProduct
            isShow={showPopupSelectStickerProduct}
            setIsShow={(show: boolean) => {
              setShowPopupSelectStickerProduct(show)
              dispatch(resetModal())
            }}
            patientCaseId={patient?.patientCase?.patientCaseId}
            doctors={doctors} />
        )
      }

      {
        confirmClose && (
          <PopupConfirmClose
            isShow={confirmClose}
            treatments={treatments}
            handleSuccess={() => onSaveSummary('save').then(() => handleTreatmentClose())}
            onReset={() => setTimeout(() => handleTreatmentClose())}
          />
        )
      }

      {popTreatmentDocument &&
        <PopTreatmentDocument
          type='treatment'
          patientCaseId={patient?.patientCase?.patientCaseId}
          servicePointId={servicePointId}
          setIsShow={(show: boolean) => setPopTreatmentDocument(show)}
        />
      }

      {popTreatmetnFees &&
        <PopupTreatmentFees
          type='payment'
          patientCaseId={patient?.patientCase?.patientCaseId}
          servicePointId={servicePointId}
          setIsShow={(show: boolean) => setPopTreatmentFees(show)}
          handleTreatmentCurrent={setTreatmentCurrent}
        />
      }

      {popOutStandingPayment &&
        <PopupOutStandingPayment
          onClose={() => setPopOutStandingPayment(false)}
          patient={patient}
          treatments={treatments}
          onSave={() => {
            setOutStandingPayment(true)
          }}
        />
      }

      {loading && <Loading show={true} type="fullLoading" />}
      {/* <RouterPrompt /> */}
    </Box >
  )
}

function a11yProps(index: number) {
  return {
    id: `payment-tab-${index}`,
    'aria-controls': `payment-tabpanel-${index}`
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div role="tab" hidden={value !== index} id={`payment-tab-${index}`} aria-labelledby={`payment-tabpanel-${index}`} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  )
}

